<se-fe-modal #modal seFeDataSize="large" [seFeDataTitle]="modalTitle()" (seFeAfterClose)="resetForm()">
  <se-fe-modal-content id="modal-content">
    <form class="catalog-form" [formGroup]="catalogForm" novalidate>
      <se-fe-form-field class="modal-form-field" [seFeDataConfig]="catalogNameConfig">
        <se-fe-form-field-text formControlName="name" seFeDataAutoComplete="off"></se-fe-form-field-text>
      </se-fe-form-field>
      <se-fe-form-field class="modal-form-field catalog-description-field" [seFeDataConfig]="catalogDescriptionConfig">
        <se-fe-form-field-text
          formControlName="description"
          seFeDataAutoComplete="off"
          [seFeDataRows]="8"></se-fe-form-field-text>
      </se-fe-form-field>

      @if (errorMessage()) {
        <se-fe-alert seFeDataType="error">
          {{ errorMessage() }}
        </se-fe-alert>
      }
    </form>

    <div class="catalog-modal-footer">
      <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="saving()" (click)="close()">Cancel</se-fe-button>
      <se-fe-button
        seFeDataEmphasis="high"
        [seFeDataIsDisabled]="saving()"
        [seFeDataIsLoading]="saving()"
        [seFeDataLoadingLabel]="savingLabel()"
        (click)="submit()">
        Save
      </se-fe-button>
    </div>
  </se-fe-modal-content>
</se-fe-modal>
